import { render, staticRenderFns } from "./About.vue?vue&type=template&id=872c9e58&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.scss?vue&type=style&index=0&id=872c9e58&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c9e58",
  null
  
)

export default component.exports